import React from 'react';
import classNames from 'classnames';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import RadioGroupField from 'components/RadioGroupField';
import { YesNo } from 'models/Fields';
import { CREATE_LISTING_OPTIONS } from 'models/DealRoom';
import useSecondStepData from './hooks';
import { ImField } from 'components/ImField';

import './SecondStep.styles.scss';
import './SecondStep.styles.responsive.scss';

type SecondStepProps = {
  className?: string;
  dealRoomId?: string;
};

const SecondStep: React.FC<SecondStepProps> = (props) => {
  const { className, dealRoomId } = props;

  const { t } = useTranslation();
  const { createListingOptions, draftOptions } = useSecondStepData();

  const classes = classNames('second-step', className);
  const {
    values: { createListing, uploadListingIM },
  } = useFormState();

  return (
    <div className={classes}>
      <h1>{t('nextStep')}</h1>
      <RadioGroupField
        styled
        options={createListingOptions}
        name="createListing"
      />

      {createListing === CREATE_LISTING_OPTIONS.DRAFT_LISTING && (
        <>
          <h2>{t('wantUsToDraftListing')}</h2>
          <RadioGroupField
            styled
            options={draftOptions}
            name="uploadListingIM"
          />

          {uploadListingIM === YesNo.Yes && <ImField dealRoomId={dealRoomId} />}
        </>
      )}
    </div>
  );
};

export default SecondStep;
